const SHARE_METHOD_CONFIG = [
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'ru', 'th'],
    order: {
      en: 1,
      ja: 1,
      ko: 2,
      'zh-Hant': 1,
      es: 1,
      pt: 1,
      de: 1,
      fr: 1,
      ru: 2,
      th: 1
    },
    linkLocales: {
      en: 'https://discord.gg/mechabreak',
      ja: 'https://discord.gg/mechabreak',
      ko: 'https://discord.gg/mechabreak',
      'zh-Hant': 'https://discord.gg/6UdhNM8fNw',
      es: 'https://discord.gg/mechabreak',
      pt: 'https://discord.gg/mechabreak',
      de: 'https://discord.gg/mechabreak',
      fr: 'https://discord.gg/mechabreak',
      ru: 'https://discord.gg/mechabreak',
      th: 'https://discord.gg/mechabreak'
    },
    name: 'Discord',
    img: require('./images/discord.png'),
    // onClick() {
    //   $$tracker.clickMainNaviBarDiscord();
    // }
  },
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'th'],
    order: {
      en: 2,
      ja: 2,
      ko: 3,
      'zh-Hant': 3,
      es: 2,
      pt: 2,
      de: 2,
      fr: 2,
      th: 3
    },
    linkLocales: {
      en: 'https://x.com/MechaBREAK',
      ja: 'https://x.com/MechaBREAKJP',
      ko: 'https://x.com/MechaBREAK_KR',
      'zh-Hant': 'https://x.com/MechaBREAKSea',
      es: 'https://x.com/MechaBREAK',
      pt: 'https://x.com/MechaBREAK',
      de: 'https://x.com/MechaBREAK',
      fr: 'https://x.com/MechaBREAK',
      th: 'https://x.com/MechaBREAK'
    },
    // name: 'X (Twitter)',
    name: 'X',
    img: require('./images/x.png'),
  },
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'ru', 'th'],
    order: {
      en: 3,
      ja: 3,
      ko: 4,
      'zh-Hant': 4,
      es: 3,
      pt: 3,
      de: 3,
      fr: 3,
      ru: 3,
      th: 4
    },
    linkLocales: {
      en: 'https://www.youtube.com/@MechaBREAK',
      ja: 'https://www.youtube.com/@MechaBREAKJP',
      ko: 'https://www.youtube.com/@MechaBREAK_KR',
      'zh-Hant': 'https://www.youtube.com/@MechaBREAEK_Sea',
      es: 'https://www.youtube.com/@MechaBREAK',
      pt: 'https://www.youtube.com/@MechaBREAK',
      de: 'https://www.youtube.com/@MechaBREAK',
      fr: 'https://www.youtube.com/@MechaBREAK',
      ru: 'https://www.youtube.com/@MechaBREAK',
      th: 'https://www.youtube.com/@MechaBREAK'
    },
    name: 'YouTube',
    img: require('./images/youtube.png'),
  },
  {
    applyLanguages: ['en', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'th'],
    order: {
      en: 4,
      'zh-Hant': 2,
      es: 4,
      pt: 4,
      de: 4,
      fr: 4,
      th: 2
    },
    linkLocales: {
      en: 'https://www.facebook.com/MechaBREAK/',
      'zh-Hant': 'https://www.facebook.com/profile.php?id=61560861745459',
      es: 'https://www.facebook.com/MechaBREAK/',
      pt: 'https://www.facebook.com/MechaBREAK/',
      de: 'https://www.facebook.com/MechaBREAK/',
      fr: 'https://www.facebook.com/MechaBREAK/',
      th: 'https://www.facebook.com/groups/mechabreakthai'
    },
    name: 'Facebook',
    img: require('./images/Facebook.png'),
  },
  {
    applyLanguages: ['en', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'th'],
    order: {
      en: 5,
      ko: 5,
      'zh-Hant': 5,
      es: 5,
      pt: 5,
      de: 5,
      fr: 5,
      th: 5
    },
    linkLocales: {
      en: 'https://www.instagram.com/mechabreak/',
      ko: 'https://www.instagram.com/mechabreak/',
      'zh-Hant': 'https://www.instagram.com/mechabreak/',
      es: 'https://www.instagram.com/mechabreak/',
      pt: 'https://www.instagram.com/mechabreak/',
      de: 'https://www.instagram.com/mechabreak/',
      fr: 'https://www.instagram.com/mechabreak/',
      th: 'https://www.instagram.com/mechabreak/'
    },
    name: 'Instagram',
    img: require('./images/Instagram.png'),
  },
  {
    applyLanguages: ['en'],
    order: {
      en: 6
    },
    linkLocales: {
      en: 'https://www.tiktok.com/@mechabreak'
    },
    name: 'TikTok',
    img: require('./images/TikTok.png'),
  },
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'ru', 'th'],
    order: {
      en: 7,
      ja: 4,
      ko: 6,
      'zh-Hant': 6,
      es: 6,
      pt: 6,
      de: 6,
      fr: 6,
      ru: 4,
      th: 6
    },
    linkLocales: {
      en: 'https://www.twitch.tv/mechabreakofficial',
      ja: 'https://www.twitch.tv/mechabreakofficial',
      ko: 'https://www.twitch.tv/mechabreakofficial',
      'zh-Hant': 'https://www.twitch.tv/mechabreakofficial',
      es: 'https://www.twitch.tv/mechabreakofficial',
      pt: 'https://www.twitch.tv/mechabreakofficial',
      de: 'https://www.twitch.tv/mechabreakofficial',
      fr: 'https://www.twitch.tv/mechabreakofficial',
      ru: 'https://www.twitch.tv/mechabreakofficial',
      th: 'https://www.twitch.tv/mechabreakofficial'
    },
    name: 'Twitch',
    img: require('./images/Twitch.png'),
  },
  {
    applyLanguages: ['ko'],
    order: {
      ko: 1
    },
    linkLocales: {
      ko: 'https://game.naver.com/lounge/Mecha_BREAK'
    },
    name: 'Naver',
    img: require('./images/Naver.png'),
  },
  {
    applyLanguages: ['ru'],
    order: {
      ru: 1
    },
    linkLocales: {
      ru: 'https://vk.com/mechabreak'
    },
    name: 'VK',
    img: require('./images/VK.png'),
  }
];

export default SHARE_METHOD_CONFIG;